import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';

export const useDateTimeFormat = (): string => {
  const ctxProps = useGlobalStateContextSelectors({
    dateTimeFormat: prop('dateTimeFormat'),
  });

  return ctxProps.dateTimeFormat;
};
